/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bolt': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7.34 14.4h-.16a.44.44 0 01-.24-.4V9.76h-3.6c-.16 0-.32-.08-.32-.24-.08-.16-.08-.32 0-.4l5.36-7.36c.08-.16.32-.16.48-.16.08.08.24.24.24.4v4.24h3.6c.16 0 .32.08.32.24.08.16.08.32 0 .4l-5.36 7.36c-.08.08-.16.16-.32.16z" _fill="#E5092B"/>'
  }
})
